import type { MoneyModel } from 'shared/ui/FormatMoney';

import type { PendingChangesModel } from '../model';

export enum CampaignStatus {
  draft = 'draft',
  inReview = 'inReview',
  paused = 'paused',
  running = 'running',
  budgetReached = 'budgetReached',
  deactivated = 'deactivated',
  noCcAdded = 'noCcAdded',
}

export type CampaignStatusModel = keyof typeof CampaignStatus;

export enum CampaignTypes {
  lead = 'Leads',
  appt = 'Appointments',
  sales = 'Sales',
}

export enum CampaignTypesTable {
  lead = 'Leads',
  appt = 'Call Center Leads',
  sales = 'Sales',
}

export enum CampaignType {
  leads = 'lead',
  appointments = 'appt',
  sales = 'sales',
  apptWithCustomSchedule = 'apptWithCustomSchedule',
}

export type CampaignTypeKey = keyof typeof CampaignTypes;

export type BidTiersModel = {
  id: number;
  bid: number;
  label?: string;
}[];

export interface WeeklyBudgetModel {
  budget: MoneyModel;
  spent: MoneyModel;
  total: MoneyModel;
  refund: MoneyModel;
  spentToBudgetPercent: number;
}

export type LastWeekBudgetModel = Omit<WeeklyBudgetModel, 'refund' | 'total'>;

export interface BidTierGroup {
  id: number;
  label: string;
  bidTiers: {
    id: number;
    label: string;
    order: number;
    leadMinimalBid: number;
    apptMinimalBid: number;
    apptMaximumBid: number;
    leadMaximumBid: number;
    campaignBidTier: {
      id: number;
      bid: number;
    };
  }[];
}

export interface ManagerCampaignModel {
  id: number;
  name: string;
  contractor: {
    id: number;
    companyName: string;
  };
  status: CampaignStatusModel;
  service: {
    id: number;
    name: string;
  };
  type: CampaignTypeKey;
  bid: number | null;
  bidTiers: BidTiersModel | null;
  bidTierGroups: BidTierGroup[] | null;
  normalizedBid: number | null;
  normalizedBidTiers: { id: number; label?: string; bid: number }[] | null;
  weeklyBudget: WeeklyBudgetModel;
  lastWeekBudget: LastWeekBudgetModel;
  isActive: boolean;
  pendingChanges: PendingChangesModel | null;
  minimalIncome: MoneyModel;
  currency: 'USD';
}
